export default __webpack_public_path__ + "static/media/Star.eb8ad86d.svg";